import { useState } from "react";
import { Link } from "react-router-dom";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=DM+Sans:wght@300;400;500;600&display=swap');

  * { margin: 0; padding: 0; box-sizing: border-box; }

  .enrich-root {
    font-family: 'DM Sans', sans-serif;
    background: #fafafa;
    color: #1a1a1a;
    min-height: 100vh;
  }

  /* NAV */
  .nav {
    background: #111;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 48px;
    height: 64px;
    position: sticky;
    top: 0;
    z-index: 100;
  }
  .nav-logo { display: flex; flex-direction: column; line-height: 1; cursor: pointer; }
  .nav-logo-name {
    font-family: 'Playfair Display', serif;
    font-size: 26px; font-weight: 700; color: #fff; letter-spacing: 1px;
  }
  .nav-logo-name span { color: #e53935; }
  .nav-logo-tagline { font-size: 10px; color: #aaa; letter-spacing: 2px; margin-top: 2px; }
  .nav-links { display: flex; gap: 36px; list-style: none; }
  .nav-links a {
    color: #fff; text-decoration: none; font-size: 13px; font-weight: 500;
    letter-spacing: 1.5px; text-transform: uppercase;
    display: flex; align-items: center; gap: 7px;
    opacity: 0.85; transition: opacity 0.2s;
  }
  .nav-links a:hover { opacity: 1; }

  /* HERO */
  .pp-hero {
    background: linear-gradient(135deg, #0f2027 0%, #1a3a4a 55%, #0f2027 100%);
    padding: 60px 48px 52px;
    position: relative;
    overflow: hidden;
  }
  .pp-hero::before {
    content: '';
    position: absolute;
    top: -80px; right: -80px;
    width: 360px; height: 360px;
    border-radius: 50%;
    background: radial-gradient(circle, #4a90d930 0%, transparent 70%);
  }
  .pp-hero::after {
    content: '';
    position: absolute;
    bottom: -60px; left: 20%;
    width: 260px; height: 260px;
    border-radius: 50%;
    background: radial-gradient(circle, #e5393520 0%, transparent 70%);
  }
  .pp-hero-inner { position: relative; z-index: 1; max-width: 860px; }
  .pp-hero-eyebrow {
    font-size: 12px; font-weight: 600; letter-spacing: 3px;
    text-transform: uppercase; color: #4a90d9; margin-bottom: 14px;
    display: flex; align-items: center; gap: 8px;
  }
  .pp-hero-eyebrow::before {
    content: '🔒';
    font-size: 14px;
  }
  .pp-hero h1 {
    font-family: 'Playfair Display', serif;
    font-size: 48px; font-weight: 700; color: #fff;
    line-height: 1.15; margin-bottom: 16px;
  }
  .pp-hero p {
    font-size: 15px; color: #9ab; line-height: 1.8; max-width: 620px;
  }
  .pp-hero-meta {
    margin-top: 28px; display: flex; gap: 12px; flex-wrap: wrap;
  }
  .pp-meta-pill {
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 99px; padding: 7px 18px;
    font-size: 12px; color: #9ab; letter-spacing: 0.5px;
    display: flex; align-items: center; gap: 6px;
  }

  /* COMMITMENT STRIP */
  .pp-commitments {
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
    padding: 0 48px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
  .pp-commit-item {
    padding: 22px 24px;
    border-right: 1px solid #f0f0f0;
    display: flex; align-items: center; gap: 14px;
  }
  .pp-commit-item:last-child { border-right: none; }
  .pp-commit-icon {
    font-size: 24px;
    background: #f5f5f5;
    border-radius: 10px;
    width: 44px; height: 44px;
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
  }
  .pp-commit-label { font-size: 13px; font-weight: 600; color: #111; }
  .pp-commit-sub { font-size: 12px; color: #888; margin-top: 2px; }

  /* LAYOUT */
  .pp-layout {
    display: grid;
    grid-template-columns: 260px 1fr;
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 24px;
    align-items: start;
    gap: 0;
  }

  /* SIDEBAR */
  .pp-sidebar {
    position: sticky;
    top: 88px;
    background: #fff;
    border-radius: 16px;
    border: 1.5px solid #e8e8e8;
    padding: 24px 0;
    box-shadow: 0 2px 16px rgba(0,0,0,0.05);
    margin-right: 32px;
    overflow: hidden;
  }
  .sidebar-title {
    font-size: 11px; font-weight: 600; letter-spacing: 2px;
    text-transform: uppercase; color: #999;
    padding: 0 20px 16px;
    border-bottom: 1px solid #f0f0f0;
  }
  .sidebar-nav { list-style: none; padding: 12px 0; }
  .sidebar-nav li a {
    display: flex; align-items: center; gap: 10px;
    padding: 9px 20px;
    font-size: 13px; color: #555; text-decoration: none;
    border-left: 3px solid transparent;
    transition: all 0.2s; line-height: 1.4;
  }
  .sidebar-nav li a:hover {
    color: #1565c0;
    border-left-color: #1565c0;
    background: #f0f7ff;
  }
  .sidebar-nav li a .s-icon { font-size: 15px; flex-shrink: 0; }

  .pp-sidebar-contact {
    margin: 12px 16px 4px;
    background: linear-gradient(135deg, #0f2027 0%, #1a3a4a 100%);
    border-radius: 12px;
    padding: 16px;
    color: #fff;
  }
  .pp-sidebar-contact h5 { font-size: 13px; font-weight: 600; margin-bottom: 8px; }
  .pp-sidebar-contact p { font-size: 12px; color: #9ab; line-height: 1.6; }
  .pp-sidebar-contact a { color: #4a90d9; text-decoration: none; font-size: 12px; }

  /* MAIN */
  .pp-content {
    background: #fff;
    border-radius: 16px;
    border: 1.5px solid #e8e8e8;
    padding: 48px 52px;
    box-shadow: 0 2px 16px rgba(0,0,0,0.05);
  }

  .pp-section {
    margin-bottom: 52px;
    padding-bottom: 52px;
    border-bottom: 1px solid #f0f0f0;
    scroll-margin-top: 90px;
  }
  .pp-section:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .section-number {
    font-size: 12px; font-weight: 700; letter-spacing: 2px;
    text-transform: uppercase; color: #1565c0; margin-bottom: 10px;
    display: flex; align-items: center; gap: 8px;
  }
  .section-heading {
    font-family: 'Playfair Display', serif;
    font-size: 24px; font-weight: 700; color: #111;
    margin-bottom: 18px; line-height: 1.3;
  }
  .section-body {
    font-size: 14.5px; line-height: 1.9; color: #444;
  }
  .section-body p { margin-bottom: 14px; }
  .section-body p:last-child { margin-bottom: 0; }

  /* DATA TABLE */
  .pp-data-table {
    width: 100%; border-collapse: collapse; margin: 20px 0;
    font-size: 13.5px; border-radius: 12px; overflow: hidden;
  }
  .pp-data-table thead tr {
    background: linear-gradient(135deg, #0f2027 0%, #1a3a4a 100%);
  }
  .pp-data-table th {
    color: #fff; padding: 13px 18px;
    text-align: left; font-weight: 600;
    font-size: 12px; letter-spacing: 1px; text-transform: uppercase;
  }
  .pp-data-table td {
    padding: 13px 18px; border-bottom: 1px solid #f0f0f0;
    vertical-align: top; line-height: 1.65; color: #444;
  }
  .pp-data-table tr:last-child td { border-bottom: none; }
  .pp-data-table tr:nth-child(even) td { background: #f8fbff; }

  /* LISTS */
  .pp-list {
    list-style: none; margin: 14px 0;
  }
  .pp-list li {
    display: flex; gap: 12px; align-items: flex-start;
    font-size: 14.5px; line-height: 1.75; color: #444;
    margin-bottom: 10px; padding: 13px 16px;
    background: #f8fbff; border-radius: 10px;
    border-left: 3px solid #1565c0;
  }
  .pp-list li .bullet { color: #1565c0; font-weight: 700; flex-shrink: 0; margin-top: 1px; font-size: 16px; }

  .pp-list.green li { background: #f0fdf4; border-left-color: #16a34a; }
  .pp-list.green li .bullet { color: #16a34a; }

  .pp-list.amber li { background: #fffbeb; border-left-color: #d97706; }
  .pp-list.amber li .bullet { color: #d97706; }

  /* CALLOUTS */
  .pp-callout {
    border-radius: 14px; padding: 20px 24px; margin: 18px 0;
    font-size: 14px; line-height: 1.75;
  }
  .pp-callout.blue {
    background: linear-gradient(135deg, #eff6ff 0%, #fff 100%);
    border: 1.5px solid #93c5fd; color: #1e3a5f;
  }
  .pp-callout.green {
    background: linear-gradient(135deg, #f0fdf4 0%, #fff 100%);
    border: 1.5px solid #86efac; color: #14532d;
  }
  .pp-callout.amber {
    background: linear-gradient(135deg, #fffbeb 0%, #fff 100%);
    border: 1.5px solid #fcd34d; color: #78350f;
  }
  .pp-callout.dark {
    background: linear-gradient(135deg, #0f2027 0%, #1a3a4a 100%);
    border: 1.5px solid #2d5a6a; color: #cde;
  }
  .pp-callout strong { font-weight: 600; }

  /* RIGHTS GRID */
  .rights-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    margin: 18px 0;
  }
  .right-card {
    background: #f8fbff;
    border: 1.5px solid #dbeafe;
    border-radius: 12px;
    padding: 18px 18px;
    transition: box-shadow 0.2s, transform 0.2s;
  }
  .right-card:hover {
    box-shadow: 0 6px 20px rgba(21,101,192,0.1);
    transform: translateY(-2px);
  }
  .right-card-icon { font-size: 24px; margin-bottom: 8px; }
  .right-card-title { font-size: 14px; font-weight: 600; color: #1565c0; margin-bottom: 6px; }
  .right-card-desc { font-size: 13px; color: #555; line-height: 1.65; }

  /* COOKIE TOGGLE */
  .cookie-row {
    display: flex; align-items: center; justify-content: space-between;
    padding: 14px 16px;
    background: #fafafa;
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    margin-bottom: 10px;
  }
  .cookie-row-info { flex: 1; }
  .cookie-row-label { font-size: 14px; font-weight: 600; color: #111; margin-bottom: 3px; }
  .cookie-row-desc { font-size: 12.5px; color: #777; }
  .cookie-toggle {
    position: relative;
    width: 44px; height: 24px;
    background: #ccc;
    border-radius: 99px;
    cursor: pointer;
    border: none;
    transition: background 0.25s;
    flex-shrink: 0;
    margin-left: 16px;
  }
  .cookie-toggle.on { background: #1565c0; }
  .cookie-toggle.disabled { opacity: 0.5; cursor: not-allowed; }
  .cookie-toggle::after {
    content: '';
    position: absolute;
    top: 3px; left: 3px;
    width: 18px; height: 18px;
    background: #fff;
    border-radius: 50%;
    transition: left 0.25s;
  }
  .cookie-toggle.on::after { left: 23px; }

  /* FOOTER */
  .footer {
    background: #111; color: #aaa;
    padding: 40px 48px;
    display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; gap: 32px;
    margin-top: 40px;
  }
  .footer-brand p { margin-top: 12px; font-size: 13px; line-height: 1.7; }
  .footer-col h4 {
    color: #fff; font-size: 13px; font-weight: 600;
    letter-spacing: 1.5px; text-transform: uppercase; margin-bottom: 16px;
  }
  .footer-col ul { list-style: none; }
  .footer-col ul li { margin-bottom: 10px; font-size: 13px; cursor: pointer; transition: color 0.2s; }
  .footer-col ul li:hover { color: #fff; }
  .footer-bottom {
    background: #0a0a0a; color: #555;
    text-align: center; padding: 16px; font-size: 12px;
  }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(16px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .pp-hero-inner { animation: fadeUp 0.6s ease forwards; }
`;

const commitments = [
  { icon: "🔐", label: "Data Security", sub: "SSL encrypted & secure" },
  { icon: "🚫", label: "No Data Selling", sub: "Your data stays private" },
  { icon: "✅", label: "Your Consent", sub: "You control your data" },
  { icon: "📧", label: "Easy Opt-Out", sub: "Unsubscribe anytime" },
];

const cookieTypes = [
  { label: "Essential Cookies", desc: "Required for core website functionality — login, booking, security.", on: true, locked: true },
  { label: "Analytics Cookies", desc: "Help us understand how visitors use our site to improve experiences.", on: true, locked: false },
  { label: "Marketing Cookies", desc: "Used to show you relevant Style Sutra offers and promotions.", on: false, locked: false },
  { label: "Preference Cookies", desc: "Remember your settings such as language and salon location.", on: true, locked: false },
];

const sections = [
  {
    id: "intro",
    icon: "📘",
    number: "01",
    title: "Introduction",
    content: ({ }) => (
      <>
        <div className="section-body">
          <p>Style Sutra Salon ("Style Sutra", "we", "us", or "our") is committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your personal information when you visit our website at www.stylesutra.com, use our mobile application, or engage with any of our services or loyalty programmes.</p>
          <p>This policy applies to all personal information we collect about you when you book an appointment, purchase a product, create an account, enrol in our loyalty programme, or interact with us in any other way. Please read this Policy carefully. By using our services, you consent to the practices described herein.</p>
        </div>
        <div className="pp-callout dark">
          <strong>Our Promise:</strong> Style Sutra does not sell, rent, or trade your personal information to third parties for their marketing purposes. Your trust is the foundation of everything we do.
        </div>
      </>
    ),
  },
  {
    id: "collect",
    icon: "📋",
    number: "02",
    title: "Information We Collect",
    content: ({ }) => (
      <>
        <div className="section-body">
          <p>We collect information you provide directly to us, as well as information gathered automatically when you interact with our digital platforms. The categories of information we may collect include:</p>
        </div>
        <table className="pp-data-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Examples</th>
              <th>How Collected</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Identity Data</strong></td>
              <td>Full name, date of birth, gender, profile photo</td>
              <td>Account registration, salon visit</td>
            </tr>
            <tr>
              <td><strong>Contact Data</strong></td>
              <td>Email address, phone number, postal address</td>
              <td>Registration, booking form</td>
            </tr>
            <tr>
              <td><strong>Transaction Data</strong></td>
              <td>Services purchased, products bought, payment method, invoice history</td>
              <td>Bookings, purchases</td>
            </tr>
            <tr>
              <td><strong>Loyalty Data</strong></td>
              <td>Points balance, redemption history, membership tier</td>
              <td>Loyalty programme activity</td>
            </tr>
            <tr>
              <td><strong>Technical Data</strong></td>
              <td>IP address, browser type, device identifiers, cookie data</td>
              <td>Automated collection via website/app</td>
            </tr>
            <tr>
              <td><strong>Usage Data</strong></td>
              <td>Pages visited, features used, session duration, click data</td>
              <td>Analytics tools</td>
            </tr>
            <tr>
              <td><strong>Communications</strong></td>
              <td>Emails, chat transcripts, feedback and reviews</td>
              <td>Direct communication with us</td>
            </tr>
            <tr>
              <td><strong>Health & Preference Data</strong></td>
              <td>Skin type, allergy information, beauty preferences (where voluntarily provided)</td>
              <td>Service consultations, forms</td>
            </tr>
          </tbody>
        </table>
        <div className="pp-callout amber">
          <strong>Sensitive Information:</strong> Any health-related data (e.g., skin conditions, allergies) you share during consultations is treated with the highest level of confidentiality and used solely to personalise and deliver safe services to you.
        </div>
      </>
    ),
  },
  {
    id: "use",
    icon: "⚙️",
    number: "03",
    title: "How We Use Your Information",
    content: ({ }) => (
      <>
        <div className="section-body">
          <p>We use the personal information we collect for the following purposes, always on a lawful basis under applicable Indian data protection law (including the Digital Personal Data Protection Act, 2023):</p>
        </div>
        <ul className="pp-list">
          <li><span className="bullet">✦</span><span><strong>Service Delivery:</strong> To process bookings, deliver salon and spa services, send appointment confirmations and reminders, and manage your account.</span></li>
          <li><span className="bullet">✦</span><span><strong>Loyalty Programme:</strong> To credit and manage points, personalise offers, and communicate membership benefits and tier upgrades.</span></li>
          <li><span className="bullet">✦</span><span><strong>Payments & Transactions:</strong> To process payments, issue invoices, handle refunds, and prevent fraud.</span></li>
          <li><span className="bullet">✦</span><span><strong>Marketing & Communications:</strong> To send promotional offers, newsletters, and event invitations — only where you have given consent or where we have a legitimate interest to do so.</span></li>
          <li><span className="bullet">✦</span><span><strong>Personalisation:</strong> To tailor our service recommendations, product suggestions, and website experience to your preferences and history.</span></li>
          <li><span className="bullet">✦</span><span><strong>Analytics & Improvement:</strong> To analyse usage patterns, measure service performance, conduct research, and improve our products and services.</span></li>
          <li><span className="bullet">✦</span><span><strong>Legal Compliance:</strong> To comply with applicable laws, regulations, court orders, and governmental requests.</span></li>
          <li><span className="bullet">✦</span><span><strong>Safety & Security:</strong> To protect Style Sutra, our staff, and our clients from fraud, abuse, or harmful activity.</span></li>
        </ul>
      </>
    ),
  },
  {
    id: "sharing",
    icon: "🤝",
    number: "04",
    title: "Sharing Your Information",
    content: ({ }) => (
      <>
        <div className="section-body">
          <p>Style Sutra does not sell or rent your personal information. We may share your data with the following categories of recipients, solely as necessary for the purposes described in this Policy:</p>
        </div>
        <ul className="pp-list green">
          <li><span className="bullet">✓</span><span><strong>Service Providers:</strong> Trusted third-party vendors who perform services on our behalf — including payment processors, SMS and email delivery platforms, cloud hosting providers, and customer support tools. All are bound by strict data processing agreements.</span></li>
          <li><span className="bullet">✓</span><span><strong>Franchise Partners:</strong> Where you visit a franchise-operated Style Sutra salon, your booking and service data may be shared with that franchise for the purpose of delivering your appointment.</span></li>
          <li><span className="bullet">✓</span><span><strong>Analytics Partners:</strong> Aggregated, anonymised usage data may be shared with analytics platforms (e.g., Google Analytics) to help us understand how our digital services are used.</span></li>
          <li><span className="bullet">✓</span><span><strong>Legal Authorities:</strong> We may disclose information to government or regulatory authorities if required by law, court order, or to protect the rights, property, or safety of Style Sutra, our clients, or the public.</span></li>
          <li><span className="bullet">✓</span><span><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your data may be transferred to the relevant parties, subject to this Policy continuing to apply.</span></li>
        </ul>
        <div className="pp-callout blue">
          <strong>Note:</strong> We never share your sensitive health or preference data with any external marketing partners. This data is used exclusively to deliver and personalise your in-salon experience.
        </div>
      </>
    ),
  },
  {
    id: "retention",
    icon: "🗂️",
    number: "05",
    title: "Data Retention",
    content: ({ }) => (
      <>
        <div className="section-body">
          <p>We retain your personal data only for as long as necessary to fulfil the purposes for which it was collected, including satisfying legal, accounting, or reporting requirements. Retention periods vary by data type:</p>
        </div>
        <table className="pp-data-table">
          <thead>
            <tr>
              <th>Data Type</th>
              <th>Retention Period</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Account & Identity Data</td>
              <td>Duration of account + 3 years</td>
              <td>Account management, dispute resolution</td>
            </tr>
            <tr>
              <td>Transaction & Payment Data</td>
              <td>7 years from transaction date</td>
              <td>GST, tax, and audit compliance</td>
            </tr>
            <tr>
              <td>Loyalty Programme Data</td>
              <td>Duration of membership + 2 years</td>
              <td>Programme management</td>
            </tr>
            <tr>
              <td>Marketing Preferences</td>
              <td>Until opt-out + 1 year</td>
              <td>Compliance with consent records</td>
            </tr>
            <tr>
              <td>Technical / Log Data</td>
              <td>90 days</td>
              <td>Security monitoring</td>
            </tr>
            <tr>
              <td>Health & Sensitivity Data</td>
              <td>Last service + 1 year</td>
              <td>Safety continuity; deleted on request</td>
            </tr>
          </tbody>
        </table>
      </>
    ),
  },
  {
    id: "rights",
    icon: "⚖️",
    number: "06",
    title: "Your Rights & Choices",
    content: ({ }) => (
      <>
        <div className="section-body">
          <p>Under applicable Indian data protection legislation, including the Digital Personal Data Protection Act, 2023, you have the following rights regarding your personal data:</p>
        </div>
        <div className="rights-grid">
          {[
            { icon: "👁️", title: "Right to Access", desc: "Request a copy of the personal data we hold about you." },
            { icon: "✏️", title: "Right to Correction", desc: "Ask us to correct inaccurate or incomplete personal data." },
            { icon: "🗑️", title: "Right to Erasure", desc: "Request deletion of your data, subject to legal obligations." },
            { icon: "🚫", title: "Right to Withdraw Consent", desc: "Withdraw marketing consent at any time without affecting prior processing." },
            { icon: "📦", title: "Right to Data Portability", desc: "Receive your data in a structured, machine-readable format." },
            { icon: "📢", title: "Right to Grievance", desc: "Lodge a complaint with our Data Protection Officer or the relevant authority." },
          ].map((r, i) => (
            <div className="right-card" key={i}>
              <div className="right-card-icon">{r.icon}</div>
              <div className="right-card-title">{r.title}</div>
              <div className="right-card-desc">{r.desc}</div>
            </div>
          ))}
        </div>
        <div className="pp-callout blue">
          <strong>How to Exercise Your Rights:</strong> Submit a request to <strong>privacy@enrichbeauty.com</strong> with your registered name, email, and the nature of your request. We will respond within 30 days of receipt.
        </div>
      </>
    ),
  },
  {
    id: "cookies",
    icon: "🍪",
    number: "07",
    title: "Cookies & Tracking Technologies",
    content: ({ cookieStates, toggleCookie }) => (
      <>
        <div className="section-body">
          <p>Our website uses cookies and similar tracking technologies to enhance your browsing experience, analyse traffic, and deliver personalised content. A cookie is a small text file placed on your device when you visit our Site.</p>
          <p>You can control your cookie preferences below. Please note that disabling certain cookies may affect the functionality of our website.</p>
        </div>
        {cookieTypes.map((c, i) => (
          <div className="cookie-row" key={i}>
            <div className="cookie-row-info">
              <div className="cookie-row-label">{c.label}{c.locked && <span style={{ marginLeft: 8, fontSize: 11, background: "#e8e8e8", borderRadius: 4, padding: "2px 6px", color: "#666" }}>Always On</span>}</div>
              <div className="cookie-row-desc">{c.desc}</div>
            </div>
            <button
              className={`cookie-toggle ${cookieStates[i] ? "on" : ""} ${c.locked ? "disabled" : ""}`}
              onClick={() => !c.locked && toggleCookie(i)}
              aria-label={`Toggle ${c.label}`}
            />
          </div>
        ))}
      </>
    ),
  },
  {
    id: "security",
    icon: "🛡️",
    number: "08",
    title: "Data Security",
    content: ({ }) => (
      <>
        <div className="section-body">
          <p>We implement appropriate technical and organisational security measures to protect your personal information against accidental or unlawful destruction, loss, alteration, unauthorised disclosure, or access. These measures include:</p>
        </div>
        <ul className="pp-list">
          <li><span className="bullet">✦</span><span>SSL/TLS encryption for all data transmitted between your browser and our servers.</span></li>
          <li><span className="bullet">✦</span><span>Encrypted storage of sensitive personal data including payment card information (processed via PCI-DSS compliant payment gateways — Style Sutra does not store card data directly).</span></li>
          <li><span className="bullet">✦</span><span>Role-based access controls ensuring staff can only access data necessary for their specific functions.</span></li>
          <li><span className="bullet">✦</span><span>Regular security assessments, penetration testing, and vulnerability management.</span></li>
          <li><span className="bullet">✦</span><span>Employee training on data privacy and security best practices.</span></li>
        </ul>
        <div className="pp-callout amber">
          <strong>Data Breach Notification:</strong> In the unlikely event of a data breach that poses a risk to your rights, we will notify you and the relevant regulatory authority in accordance with applicable law, typically within 72 hours of becoming aware.
        </div>
      </>
    ),
  },
  {
    id: "children",
    icon: "👶",
    number: "09",
    title: "Children's Privacy",
    content: ({ }) => (
      <>
        <div className="section-body">
          <p>Our services are not directed to individuals under the age of 18. We do not knowingly collect personal data from minors. If a parent or guardian becomes aware that their child has provided us with personal information without their consent, they should contact us at privacy@enrichbeauty.com and we will promptly delete such information.</p>
          <p>Children may receive services at Style Sutra salons when accompanied by a consenting parent or guardian, who is responsible for providing any necessary personal data on the child's behalf.</p>
        </div>
      </>
    ),
  },
  {
    id: "updates",
    icon: "📝",
    number: "10",
    title: "Updates to This Policy & Contact",
    content: ({ }) => (
      <>
        <div className="section-body">
          <p>We may update this Privacy Policy from time to time to reflect changes in our practices, technology, legal requirements, or for other operational reasons. When we make material changes, we will notify you via email or by posting a prominent notice on our website, and update the "Last Updated" date at the top of this page.</p>
          <p>We encourage you to review this Policy periodically. Your continued use of our services after any changes constitutes your acceptance of the updated Policy.</p>
        </div>
        <div className="pp-callout dark">
          <strong>Data Protection Officer / Grievance Officer</strong><br /><br />
          For any privacy-related queries, complaints, or requests, please contact:<br /><br />
          📧 <a href="mailto:privacy@enrichbeauty.com" style={{ color: "#4a90d9" }}>privacy@enrichbeauty.com</a><br />
          📞 1800-266-5300 (Toll Free, Mon–Sat, 10am–7pm IST)<br />
          📍 Style Sutra Salon, SCO 16, Sector 2, Panchkula, Haryana, India
        </div>
      </>
    ),
  },
];

export default function EnrichPrivacyPolicy() {
  const [cookieStates, setCookieStates] = useState(cookieTypes.map(c => c.on));

  const toggleCookie = (i) => {
    setCookieStates(prev => {
      const next = [...prev];
      next[i] = !next[i];
      return next;
    });
  };

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="enrich-root">
      <style>{styles}</style>

      {/* NAV */}
      <nav className="nav">
        <Link to="/" style={{ textDecoration: "none" }}>
          <div className="nav-logo">
            <div className="nav-logo-name">Style <span>S</span>utra</div>
            <div className="nav-logo-tagline">where beauty meets elegance</div>
          </div>
        </Link>
        <ul className="nav-links">
          <li><a href="#">🛍 Services</a></li>
          <li><a href="#">🏪 Stores</a></li>
          <li><a href="#">📋 About Us</a></li>
        </ul>
      </nav>

      {/* HERO */}
      <div className="pp-hero">
        <div className="pp-hero-inner">
          <div className="pp-hero-eyebrow">Privacy Policy</div>
          <h1>Your Privacy Matters to Us</h1>
          <p>At Style Sutra, we believe that beauty and trust go hand in hand. This policy explains exactly how we collect, use, and protect the personal information you share with us — clearly and without jargon.</p>
          <div className="pp-hero-meta">
            <span className="pp-meta-pill">📅 Last Updated: February 2025</span>
            <span className="pp-meta-pill">🇮🇳 DPDPA 2023 Compliant</span>
            <span className="pp-meta-pill">🔒 SSL Secured</span>
            <span className="pp-meta-pill">📍 SCO 16, Sector 2, Panchkula</span>
          </div>
        </div>
      </div>

      {/* COMMITMENTS STRIP */}
      <div className="pp-commitments">
        {commitments.map((c, i) => (
          <div className="pp-commit-item" key={i}>
            <div className="pp-commit-icon">{c.icon}</div>
            <div>
              <div className="pp-commit-label">{c.label}</div>
              <div className="pp-commit-sub">{c.sub}</div>
            </div>
          </div>
        ))}
      </div>

      {/* LAYOUT */}
      <div className="pp-layout">
        {/* SIDEBAR */}
        <aside className="pp-sidebar">
          <div className="sidebar-title">Contents</div>
          <ul className="sidebar-nav">
            {sections.map(s => (
              <li key={s.id}>
                <a href={`#${s.id}`} onClick={e => { e.preventDefault(); scrollTo(s.id); }}>
                  <span className="s-icon">{s.icon}</span>
                  <span style={{ color: "#1565c0", fontWeight: 700, marginRight: 4 }}>{s.number}</span>
                  {s.title}
                </a>
              </li>
            ))}
          </ul>
          <div className="pp-sidebar-contact">
            <h5>🔒 Privacy Questions?</h5>
            <p>Contact our Data Protection Officer at <a href="mailto:privacy@enrichbeauty.com">privacy@enrichbeauty.com</a> or call 1800-266-5300.</p>
          </div>
        </aside>

        {/* CONTENT */}
        <main className="pp-content">
          {sections.map(s => (
            <div className="pp-section" key={s.id} id={s.id}>
              <div className="section-number">
                <span>{s.icon}</span> Section {s.number}
              </div>
              <h2 className="section-heading">{s.title}</h2>
              <s.content cookieStates={cookieStates} toggleCookie={toggleCookie} />
            </div>
          ))}
        </main>
      </div>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-brand">
          <div className="nav-logo">
            <div className="nav-logo-name" style={{ color: "#fff" }}>Style <span style={{ color: "#e53935" }}>S</span>utra</div>
            <div style={{ fontSize: 10, color: "#aaa", letterSpacing: 2, marginTop: 2 }}>where beauty meets elegance</div>
          </div>
          <p>SCO 16, Sector 2, Panchkula. Look good, feel great.</p>
        </div>
        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            {["Hair", "Skin & Facials", "Body Treatments", "Nail Art", "Bridal Packages"].map(l => <li key={l}>{l}</li>)}
          </ul>
        </div>
        <div className="footer-col">
          <h4>Legal</h4>
          <ul>
            {["Privacy Policy", "Terms & Conditions", "Cookie Policy", "Refund Policy"].map(l => <li key={l}>{l}</li>)}
          </ul>
        </div>
        <div className="footer-col">
          <h4>Connect</h4>
          <ul>
            {["Instagram", "Facebook", "YouTube", "Contact Us"].map(l => <li key={l}>{l}</li>)}
          </ul>
        </div>
      </footer>
      <div className="footer-bottom">© 2025 Style Sutra Salon. All rights reserved.</div>
    </div>
  );
}